import { createFileRoute, notFound } from "@tanstack/react-router";
import { APIError } from "web-core/utils";
import {
  defferedLoadsManagerQueryOptions,
  fundPerformanceQueryOptions,
  fundPortfolioQueryOptions,
  fundQueryOptions,
  historicalNavQueryOptions,
} from "creso-core/hooks";
import {
  FundDefferedLoadsManager,
  FundPerformance,
  FundPortfolio,
  HistoricalNav,
} from "creso-core/types";
import { format } from "date-fns";
import { lazy } from "react";

const Component = lazy(() => import("@funds/pages/fund"));

export const Route = createFileRoute("/(auth)/_headed/funds/$fund_id")({
  component: Component,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const endDate = new Date();
    const startDate = new Date(
      endDate.getFullYear() - 1,
      endDate.getMonth(),
      1
    );
    const [fund, performance, portfolio, otherInfo, historicalNav] =
      await Promise.allSettled([
        queryClient.ensureQueryData(fundQueryOptions(params.fund_id)),
        queryClient.ensureQueryData(
          fundPerformanceQueryOptions(params.fund_id)
        ),
        queryClient.ensureQueryData(fundPortfolioQueryOptions(params.fund_id)),
        queryClient.ensureQueryData(
          defferedLoadsManagerQueryOptions(params.fund_id)
        ),
        queryClient.ensureQueryData(
          historicalNavQueryOptions({
            fundId: params.fund_id,
            startDate: format(startDate, "yyyy-MM-dd"),
            endDate: format(endDate, "yyyy-MM-dd"),
          })
        ),
      ]);

    // The page can't render without the fund, unlike the other sections
    if (fund.status === "rejected") {
      if (fund.reason instanceof APIError && fund.reason.status === 404) {
        throw notFound();
      }
      throw fund.reason;
    }

    return {
      fund: fund.value,
      performance:
        performance.status === "fulfilled"
          ? performance.value
          : ({} as FundPerformance),
      portfolio:
        portfolio.status === "fulfilled"
          ? portfolio.value
          : ({} as FundPortfolio),
      otherInfo:
        otherInfo.status === "fulfilled"
          ? otherInfo.value
          : ({} as FundDefferedLoadsManager),
      historicalNav:
        historicalNav.status === "fulfilled"
          ? historicalNav.value
          : ([] as HistoricalNav[]),
    };
  },
});
